import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import Moment from 'react-moment';
import Logs from './ircLogs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../common/loader';
import './_irc-logs.scss';
import {
  getAllLogs,
  getOneWeekLogs,
  getOneDayLogs,
} from '../../services/logsService';

class IRClogs extends Component {
  state = {
    logsData: [],
    filteredData: [],
    loading: true,
    error: '',
    filter: '',
    startDate: '',
    endDate: '',
  };

  async componentDidMount() {
    this.getLogs('1w');
  }

  async getLogs(param) {
    try {
      const { data: logsData } = await getAllLogs(param);

      if (logsData.length) {
        const startDate = logsData[0].date;
        const endDate = logsData[logsData.length - 1].date;

        this.setState({
          logsData,
          loading: false,
          startDate,
          endDate,
        });
      } else {
        this.setState({
          logsData: [],
          loading: false,
        });
      }
    } catch (error) {
      this.setState({
        loading: false,
        logsData: [],
        error: 'Something went wrong',
      });
      // console.log("Logs Fetch Error ::::>", error);
    }
  }

  handleFilter = (value) => {
    this.setState({ loading: true, logsData: [], startDate: '', endDate: '' });
    // console.log("HANDLE FILTER", value);
    this.getLogs(value);
  };

  renderDates() {
    // console.log("INSIDE RENDER DATE --------------");
    // console.log("STATES ", this.state);

    const { loading, startDate, endDate, error } = this.state;

    if (loading) { return <Loader />; }
    if (error) { return <p>Something went wrong</p>; }

    if (!startDate || !endDate) { return null; }

    return (
      <div
        className="market-inner-col d-flex justify-content-between"
        style={ { maxWidth: this.props.Width } }>
        <span
          className="logs-date"
          style={ {
            color: 'var(--pDescColor)',
            transition: 'color 0.2s ease-out, background 0.2s ease-out',
          } }>
          <Moment format="MMM D, YYYY" withTitle>
            {startDate}
          </Moment>
        </span>

        <span
          className="logs-date"
          style={ {
            color: 'var(--text-date-to)',
            transition: 'color 0.2s ease-out, background 0.2s ease-out',
          } }>
          to
        </span>

        <span
          className="logs-date"
          style={ {
            color: 'var(--pDescColor)',
            transition: 'color 0.2s ease-out, background 0.2s ease-out',
          } }>
          <Moment format="MMM D, YYYY" withTitle>
            {endDate}
          </Moment>
        </span>
      </div>
    );
  }

  renderFilter() {
    const { filter } = this.state;

    return (
      <div className="logs-filter-wrap justify-content-center">
        <div className="row logs-filter">
          <div
            className="col text-center p-0 logs-filter-label"
            onClick={ () => this.handleFilter('1d') }>
            1d
          </div>
          <div
            className="col text-center p-0 logs-filter-label"
            onClick={ () => this.handleFilter('1w') }>
            1w
          </div>
          <div
            className="col text-center p-0 logs-filter-label"
            onClick={ () => this.handleFilter('3m') }>
            3m
          </div>
          <div
            className="col text-center p-0 logs-filter-label"
            onClick={ () => this.handleFilter('ytd') }>
            YTD
          </div>
          <div
            className="col text-center p-0 logs-filter-label"
            onClick={ () => this.handleFilter() }>
            All
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, logsData, error, filteredData } = this.state;

    return (
      <div className="row">
        <div className="col-12 irc-logs-col">
          <div
            className="irc-log-col pt-3 pl-3 pr-3 "
            style={ {
              background: 'var(--cardBg)',
              border: 'var(--card-border)',
              transition: 'color 0.2s ease-out, background 0.2s ease-out',
            } }>
            <div className="market-inner-col d-flex justify-content-between mb-3">
              <span className="badge badge-warning market-bedge">
                SOCIAL IRC LOG
              </span>
              <img
                className="img-fluid"
                src={ require('../../assets/icons/share-icon.svg') }
                alt="share" />
            </div>

            {this.renderDates()}

            <div className="row mt-3">
              <div className="col-12 log-col mb-3">
                <Logs
                  logsData={ logsData }
                  loading={ loading }
                  error={ error }
                  filter="" />
              </div>
            </div>
            <div className="row position-relative down-arrow-wrap">
              <div className="col-2 p-0 text-right position-absolute down-arrow">
                <button
                  className="btn btn-circle btn-circle-sm"
                  style={ {
                    background: 'var(--irc-logs-share)',
                    border: 'var(--irc-logs-share-border)',
                  } }>
                  <img
                    className="img-fluid"
                    src={ require('../../assets/icons/down-arrow.svg') } />
                </button>
              </div>
            </div>

            <div
              className="row shadow-row"
              style={ { background: 'var(--shadow-row)' } }>
              <div className="col position-relative p-0" />
            </div>

            <div
              className="row irc-logs-filter-wrap justify-content-center p-1"
              style={ { background: 'var(--irc-logs-filter)' } }>
              <div className="col-10 irc-logs-filter p-0 justify-content-center">
                {this.renderFilter()}
              </div>
              <div className="col-2 p-0 text-right ">
                <button
                  className="btn btn-circle btn-circle-sm"
                  style={ {
                    background: 'var(--irc-logs-share)',
                    border: 'var(--irc-logs-share-border)',
                  } }>
                  <img
                    className="img-fluid plane-icon"
                    src={ require('../../assets/icons/plane-icon.svg') } />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IRClogs;
